/*
 * Purpose: Manage Access Shell tab mode and provide a handler for switching between modes.
 * Boundary: Custom hook only; owns local state; no UI rendering.
 * Invariants:
 * - Always initializes with a valid mode ('login' | 'register').
 */

import { useState } from "react";

// Hook useAccessShell:
// Tracks the active tab mode and provides a switch handler
export function useAccessShell({ defaultMode = "login" } = {}) {
    // State: Active mode
    const [mode, setMode] = useState(defaultMode);

    // Handler: Tab click to switch mode
    const onTab = (next) => (e) => {
        e.preventDefault();
        setMode(next);
    };

    // Return: Mode and handler
    return { mode, onTab };
}